import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { updateFormProperties } from 'apps/auth/actions/formAction';
import PreCheckPopup from 'apps/auth/components/common/send/popups/Precheck/PreCheckPopup';
import OnboardingQuestionnaireModal from 'apps/auth/components/send/modals/OnboardingQuestionnaireModal';
import { PAYMENT_FLINKS } from 'apps/auth/constants/Constants';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_SEND_FLINK_ACTION, AUTH_SEND_FLINK_CHECK_STATUS } from 'apps/auth/constants/UrlConstants';
import { fetchData } from 'apps/auth/helpers/api';
import { timer } from 'apps/auth/helpers/utils';
import { useExtra } from 'apps/auth/hooks/selectors';

import IframeModal from '../../common/Modal/IframeModal';

const defaultData = {
    accountId: null,
    loginId: null,
    institution: null,
};

const detectFLinkSteps = (saveData, props) => (event) => {
    if (event.data) {
        const { step, accountId, loginId, institution } = event.data;

        if (step === 'ACCOUNT_SELECTED' && accountId) {
            saveData({ accountId });
        }

        if (step === 'REDIRECT' && accountId && loginId && institution) {
            saveData({ accountId, loginId, institution });
            setTimeout(() => {
                props.modalRef?.current?.close();
            }, 3000);
        }
    }
};

const FlinksModal = (props) => {
    const [accountId, setAccountId] = useState();
    const [loginId, setLoginId] = useState();
    const [institution, setInstitution] = useState();
    const [paymentId, setPaymentId] = useState();
    const timerId = useRef(null);
    const { paymentId: extraPaymentId, flinkCheckStatus, flink, useQuestionnaireScreen, questionnaire } = useExtra();

    const initData = () => {
        setInstitution(defaultData.institution);
        setAccountId(defaultData.accountId);
        setLoginId(defaultData.loginId);
    };

    const saveData = (newData) => {
        newData.institution && setInstitution(newData.institution);
        newData.loginId && setLoginId(newData.loginId);
        newData.accountId && setAccountId(newData.accountId);
    };

    useEffect(() => {
        if (accountId && loginId && institution && paymentId) {
            const params = new URLSearchParams({ accountId, loginId, institution, paymentId });
            props.updateFormProperties(SEND_FORM_NAME, `${AUTH_SEND_FLINK_ACTION}?${params.toString()}`, false).then(() => {
                props.submitRef.current.click();
            });
        }
    }, [accountId && loginId && institution]);

    useEffect(() => {
        if (flink && props.paymentSourceFromMethod === PAYMENT_FLINKS) {
            if (extraPaymentId) {
                setPaymentId(extraPaymentId);
            }
            initData();
        }
    }, [flink, props.paymentSourceFromMethod]);

    useEffect(() => {
        if (flinkCheckStatus) {
            checkFlinkStatus();
        }
    }, [flinkCheckStatus]);

    const checkFlinkStatus = () => {
        timerId.current = timer(
            timerId.current,
            () => {
                props.toggleSpinner(true);
                fetchData(AUTH_SEND_FLINK_CHECK_STATUS + '?paymentId=' + extraPaymentId).then(({ extra, messageBodyMessages }) => {
                    if (extra.payStatusIsFail) {
                        clearInterval(timerId.current);
                        if (messageBodyMessages) {
                            props.updateMessages(messageBodyMessages);
                        }
                        props.toggleSpinner(false);
                    } else if (extra.extFromAccount) {
                        clearInterval(timerId.current);
                        props.toggleSpinner(false);
                        const openPrecheckPopup = () => {
                            props.popupRef?.current?.open(<PreCheckPopup popupRef={props.popupRef} formName={props.formName} />);
                        };
                        if (useQuestionnaireScreen && questionnaire?.fields?.length > 0) {
                            props.modalRef?.current?.open(<OnboardingQuestionnaireModal modalRef={props.modalRef} onSubmitSuccess={openPrecheckPopup} />);
                        } else {
                            openPrecheckPopup();
                        }
                    } else {
                        checkFlinkStatus();
                    }
                });
            },
            5000,
        );
    };

    return <IframeModal modalRef={props.modalRef} marginNegative addEventListener iframeTag={flink} detectFLinkSteps={detectFLinkSteps(saveData, props)} />;
};

FlinksModal.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    submitRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    paymentSourceFromMethod: PropTypes.string,
    formName: PropTypes.string,
};

export default connect(null, {
    updateMessages,
    updateFormProperties,
    toggleSpinner,
})(FlinksModal);
